import isMobile from '../util/isMobile';

export default {
    isMobile
};